module.exports = __webpack_public_path__ + "fonts/da18edd.woff2";